/**
 * @flow
 * @relayHash 462292b3dc1aaf86d00fc3ffbf933378
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateFreelancerEmailRequestInput = {|
  newEmail?: ?string,
  clientMutationId?: ?string,
|};
export type UpdateFreelancerEmailRequestMutationVariables = {|
  input: UpdateFreelancerEmailRequestInput
|};
export type UpdateFreelancerEmailRequestMutationResponse = {|
  +updateFreelancerEmailRequest: ?{|
    +emailSent: ?boolean,
    +emailAlreadyExists: ?boolean,
  |}
|};
export type UpdateFreelancerEmailRequestMutation = {|
  variables: UpdateFreelancerEmailRequestMutationVariables,
  response: UpdateFreelancerEmailRequestMutationResponse,
|};
*/


/*
mutation UpdateFreelancerEmailRequestMutation(
  $input: UpdateFreelancerEmailRequestInput!
) {
  updateFreelancerEmailRequest(input: $input) {
    emailSent
    emailAlreadyExists
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateFreelancerEmailRequestInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateFreelancerEmailRequest",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateFreelancerEmailRequestPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "emailSent",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "emailAlreadyExists",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateFreelancerEmailRequestMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateFreelancerEmailRequestMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateFreelancerEmailRequestMutation",
    "id": null,
    "text": "mutation UpdateFreelancerEmailRequestMutation(\n  $input: UpdateFreelancerEmailRequestInput!\n) {\n  updateFreelancerEmailRequest(input: $input) {\n    emailSent\n    emailAlreadyExists\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5fff40706246a325dff997c64dfe10f7';
module.exports = node;
